import { jsx } from "react/jsx-runtime";
import { memo, forwardRef } from "react";
import { IconBase } from "src/components/ui/IconBase";
export default memo(forwardRef(function IconSvgAdd({
  className,
  "data-test-id": dataTest = "IconAdd",
  ...props
}, ref) {
  return /* @__PURE__ */ jsx(IconBase, { ...props, "data-test-id": dataTest, className, innerRef: ref, children: /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", children: /* @__PURE__ */ jsx("path", { fill: "currentColor", d: "M13 11V7h-2v4H7v2h4v4h2v-4h4v-2h-4z" }) }) });
}));
